import { isStoreGalleryImage } from '../constants/storeImageCategories';

export const sortGalleryImages = (images) =>
  [...(images || [])].sort((left, right) => {
    const sortDelta = (left.sortOrder ?? 0) - (right.sortOrder ?? 0);
    if (sortDelta !== 0) {
      return sortDelta;
    }

    return String(left.id || '').localeCompare(String(right.id || ''));
  });

export const galleryImagesFromStore = (store) =>
  sortGalleryImages((store?.images || []).filter(isStoreGalleryImage));
